export default (props) => (
  /**
   * Ícone de uma borracha cor parametrizada.
   * Utilizado para limpeza dos filtros
   * na tabela de atributos.
   */
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
   >
    <path
      d="M19.0115 6.76575L13.2157 1.02092C12.694 0.503443 11.8462 0.503443 11.3204 1.02092L4.59535 7.69559C4.34265 7.94625 4.20407 8.2818 4.20407 8.63353C4.20407 8.77502 4.22852 8.91652 4.26928 9.04994C4.24483 9.06206 4.22445 9.07823 4.20407 9.09845L1.12683 12.1508C0.796693 12.4782 0.613281 12.9149 0.613281 13.3757C0.613281 13.8407 0.796693 14.2732 1.12683 14.6007L3.67014 17.1234C3.9962 17.4468 4.44454 17.6328 4.90511 17.6328H8.20243C8.66708 17.6328 9.10726 17.4509 9.4374 17.1234L10.8639 15.7084C10.8843 15.6882 10.9006 15.668 10.9128 15.6438C11.0473 15.6882 11.19 15.7084 11.3286 15.7084C11.6709 15.7084 12.0133 15.5791 12.2742 15.3203L14.0145 13.594L19.0115 8.64565C19.2642 8.395 19.4028 8.05945 19.4028 7.70772C19.4028 7.356 19.2642 7.0164 19.0115 6.76575ZM18.5713 8.20903L11.8421 14.8837C11.5609 15.1627 11.1044 15.1627 10.8273 14.8837L5.03553 9.13483C4.90103 9.00142 4.82359 8.8195 4.82359 8.62948C4.82359 8.43947 4.89696 8.26159 5.03553 8.12413L11.7647 1.4535C12.0459 1.17455 12.4983 1.17455 12.7796 1.4535L18.5713 7.19833C18.7058 7.33174 18.7832 7.51367 18.7832 7.70368C18.7832 7.89369 18.7058 8.07562 18.5713 8.20903Z"
      fill={props.fill ? props.fill : 'currentColor'}
    />
  </svg>
);
